export function fmtDateTime(utcString) {
  if (!utcString) return "—";
  return new Date(utcString).toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
    timeZone: "Asia/Kolkata",
  }) + " IST";
}

export function fmtDate(utcString) {
  if (!utcString) return "—";
  return new Date(utcString).toLocaleDateString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    timeZone: "Asia/Kolkata",
  });
}
